export var ScheduleBudgetingRoutes = {
    "/schedule-budgeting": {
        "loginRequired": true,
        "name": "appLayout.schedule.budgeting",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "scheduleBudgetingContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./schedule-budgeting.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["schedule-budgeting"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Budgeting"
            }
        ],
        "onEnter": ['$q', 'userServices', '$state', 'TeamScheduleService', 'userPermissions',
            function ($q, userServices, $state, TeamScheduleService, userPermissions) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var promises = {};

                        promises['policyParser'] = userPermissions.getBrandPolicy(brand.id);
                        promises['isBudgetingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.SCHEDULE_BUDGETING, brand.id);

                        $q.all(promises)
                            .then(function (res) {
                                if (res.policyParser && res.isBudgetingEnabled) {
                                    var canManageBudget = res.policyParser.has(userPermissions.PERMISSIONS.MANAGE_BUDGET);
                                    if (!canManageBudget) {
                                        $state.go('appLayout.schedule.main');
                                    }
                                } else {
                                    $state.go('appLayout.schedule.main');
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    }
};